import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LocalService, ManagerService } from 'src/app/core';

@Component({
  selector: 'app-discussion-board',
  templateUrl: './discussion-board.component.html',
  styleUrls: ['./discussion-board.component.scss']
})
export class DiscussionBoardComponent implements OnInit {

  constructor(private managerService: ManagerService) { }
  @Input() chatData: any;
  @Output() onBackClick = new EventEmitter();
  @Output() onCloseClick = new EventEmitter();
  @Input() approverPage:any;
  comments: any = '';
  userProfile: any;
  chatDataList: any = [];
  @ViewChild('scrollContainer') private chatScrollContainer: ElementRef;
  disableButton: boolean = false;

  ngOnInit() {
    this.getCommentsById();
    this.userProfile = LocalService.get('userProfile');
  }

  getCommentsById() {
    this.disableButton = true;
    this.managerService.getCommentsById(this.chatData).subscribe((data) => {
      this.chatDataList = data;
      this.comments = '';
      this.disableButton = false;
      setTimeout(() => {
        try {
          this.chatScrollContainer.nativeElement.scrollTo({left: 0 , top: this.chatScrollContainer.nativeElement.scrollHeight, behavior: 'smooth'});
        } catch(err) { }  
      }, 500);
    }, err => {
      console.log(err)
    });
  };

  goBackToStatusScreen() {
    this.onBackClick.emit();
  };

  closeDialog() {
    this.onCloseClick.emit();
  };

  getShortName(name) {
    return name.match(/\b(\w)/g).join('')
  };

  addCommentsById() {
    let queryParams 
    if(this.chatData.fileData.name=='chatModal'){
      queryParams = '?fileId='+this.chatData.fileData.approverData.fileId+'&comments='+this.comments;
    }else{
       queryParams = '?fileId='+this.chatData.fileData.id+'&comments='+this.comments;
    }
    
    this.managerService.addCommentsById(queryParams).subscribe((data) => {
      this.getCommentsById()
    }, err => {
      console.log(err)
    });
  };

  getLocalDate(data) {
    return data ? new Date(data).toLocaleDateString() : null
  };
  getLocalDateandTime(data){
  

    let options:{}={timeStyle:'short'}
    let dateObj=new Date(data).toLocaleDateString()+', at '+new Date(data).toLocaleString("en-US",options)
    
    return data ? dateObj : null;
  }

  getFileType(fileName) {
    let fileImage = '<span class="icon-file-o"></span>'
    if (fileName) {
      const extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
      if (extension === 'pdf') {
        fileImage = '<span class="icon-file-pdf-o"></span>'
      }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') {
        fileImage = '<span class="icon-file-excel-o"></span>'
      }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        fileImage = '<span class="icon-file-image-o"></span>'
      }
    }
    return fileImage;
  };

  getClassByFileType(fileName) {
    let fileColor = ''
    if (fileName) {
      const extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
      if (extension === 'pdf') {
        fileColor = 'pdf-color'
      }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') {
        fileColor = 'excel-color'
      }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        fileColor = 'image-color'
      }
    }
    return fileColor;
  }
}
